import { createFileRoute } from "@tanstack/react-router";

import BuiltinToolsAdmin from "@/components/BuiltinToolsAdmin";

// Passthrough, same shape as every other admin route (see feature-toggles.tsx): the console
// component owns everything, admin/route.tsx owns the shell and the gate.
export const Route = createFileRoute("/admin/builtin-tools")({
  component: BuiltinToolsAdmin,
});
